'use client';

import Image from 'next/image';
import { Fragment, memo } from 'react';
import { BaseLinePlus } from '@/app/components/icons/BaseLinePlus';
import { ImageWithPlaceholder } from '@/app/components/shared/ImageWithPlaceholder';
import lineArrow from '../_assets/lineArrow.png';

interface PosterGroupProps {
  poster: string[];
}

/**
 * 渲染多个海报并在它们之间添加连接图标
 */
const PosterGroup = memo(({ poster }: PosterGroupProps) => {
  return (
    <>
      {poster.map((item, index) => (
        <Fragment key={item}>
          <ImageWithPlaceholder
            src={item}
            alt={`poster-${index}`}
            className="max-h-[84px] w-auto rounded-8 object-contain md:max-h-[42px] md:rounded-[4px]"
            width={1080}
            height={1080}
          />
          {index < poster.length - 1 &&
            (poster.length > 2 ? (
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-system-white24 md:size-[10px]">
                <BaseLinePlus className="size-4 md:size-[7px]" />
              </div>
            ) : (
              <div className="flex h-[88px] w-[88px] items-center justify-center md:size-[10px]">
                <Image
                  src={lineArrow.src}
                  alt="lineArrow"
                  width={88}
                  height={88}
                  className="size-[88px] md:size-[10px]"
                />
              </div>
            ))}
        </Fragment>
      ))}
    </>
  );
});

PosterGroup.displayName = 'PosterGroup';

export default PosterGroup;
